import { useLocation, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { useState, useRef } from "react";
import axios from "axios";

import { DropdownIndicator } from "../../../components/header/headerTop/headerSelects/selects";
import { customStyles2 } from "../../../components/header/headerTop/headerSelects/selects";
import { ArrowLeftIcon } from "../../../components/icons/ArrowLeftIcon";
import getHost, { link } from "../../../store/host-store";
import { token } from "../../../App";
import s from "./style.module.sass";
import Editor from "../../../UI/Editors/Editor";

const FaqNewQuestion = () => {
    const [options, setOptions] = useState([]);
    const [success, setSuccess] = useState(false);
    const editorRefQuestion = useRef(null);
    const editorRefAnswer = useRef(null);

    const history = useNavigate();
    const location = useLocation();

    const loadOptions = (inputValue, callback) => {
        let options = [];
        axios
            .create({
                baseURL: `${link}`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            })
            .get(`faq-section?filter[type_id]=${location.state.tabId}`)
            .then((response) => {
                response.data.data.forEach((permission) => {
                    options.push({
                        label: permission.title,
                        value: permission.id,
                    });
                    callback(options.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase())));
                });
            });
    };

    const submitHandler = (e) => {
        e.preventDefault();

        const formData = new FormData();

        if (editorRefQuestion.current) {
            formData.append("question", editorRefQuestion.current);
        }
        if (editorRefAnswer.current) {
            formData.append("answer", editorRefAnswer.current);
        }

        formData.append("type_id", location.state.tabId);
        formData.append("section_id", options.value);
        formData.append("active", 1);

        axios
            .post(
                getHost({
                    controller: "faq-element",
                }),
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: token,
                    },
                }
            )
            .then((result) => {
                if (result.data.success) {
                    setSuccess(true);
                }
            });
    };

    return (
        <div className="admin__layout">
            <form className={s.create} onSubmit={submitHandler}>
                <div className={s.top_wrapper}>
                    <div className={s.title}>
                        <div className="admin__back-arrow" onClick={() => history(-1)}>
                            <ArrowLeftIcon />
                        </div>
                        <h3>Создание вопроса</h3>
                    </div>
                    <div>
                        <button type="submit" className="admin__btn-blue">
                            Сохранить
                        </button>
                        {success && (
                            <div className={s.success}>
                                <span className="admin__success">Вопрос создан успешно</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className={s.bottom_wrapper}>
                    <AsyncSelect
                        key={options}
                        components={{ DropdownIndicator }}
                        placeholder={"Секция"}
                        cacheOptions
                        defaultOptions
                        onChange={setOptions}
                        value={options}
                        styles={customStyles2}
                        loadOptions={loadOptions}
                    />
                </div>
                <div className={s.question}>
                    <h3>Вопрос</h3>
                    <Editor editorRef={editorRefQuestion}/>
                </div>
                <div>
                    <h3>Ответ</h3>
                    <Editor editorRef={editorRefAnswer}/>
                </div>
            </form>
        </div>
    );
};

export default FaqNewQuestion;
